export default __webpack_public_path__ + "static/media/email2.ba9f4d42.png";